"use client";

export const runtime = "edge";

import { useEffect, useState } from "react";
import Link from "next/link";
import { ChevronRight, ZoomIn } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@/hooks/useStore";
import { getSchoolFacilityList } from "@/store/controller/schoolFacility.controller";
import { ImageLightbox } from "../../components/landing/imageLightbox";

export default function FasilitasListPage() {
  const dispatch = useAppDispatch();
  const facilities = useAppSelector((state) => state.schoolFacility.list);
  const [lightbox, setLightbox] = useState<number | null>(null);

  useEffect(() => {
    dispatch(getSchoolFacilityList({ limit: 100 }));
  }, [dispatch]);

  return (
    <div className="pt-24 sm:pt-28">
      {lightbox !== null && (
        <ImageLightbox
          src={facilities[lightbox].image}
          alt={facilities[lightbox].description}
          title={facilities[lightbox].title}
          onClose={() => setLightbox(null)}
          onPrev={() => setLightbox((previousIndex) => (previousIndex! - 1 + facilities.length) % facilities.length)}
          onNext={() => setLightbox((previousIndex) => (previousIndex! + 1) % facilities.length)}
          hasPrev={lightbox > 0}
          hasNext={lightbox < facilities.length - 1}
        />
      )}

      <div className="bg-green-800 py-12 sm:py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-2 text-green-300 text-sm mb-4">
            <Link href="/" className="hover:text-white transition-colors">
              Beranda
            </Link>
            <ChevronRight size={14} />
            <span className="text-white">Fasilitas</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-3">Galeri Fasilitas</h1>
          <p className="text-green-200 max-w-xl">
            Fasilitas lengkap dan modern untuk mendukung proses belajar mengajar yang optimal.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {facilities.map((facility, facilityIndex) => (
            <div
              key={facility.slug}
              className="group flex flex-col rounded-2xl border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative h-48 overflow-hidden cursor-pointer" onClick={() => setLightbox(facilityIndex)}>
                <img
                  src={facility.image}
                  alt={facility.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity">
                  <ZoomIn size={16} />
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h2 className="font-bold text-gray-900 text-lg mb-1">{facility.title}</h2>
                <p className="text-gray-500 text-sm mb-4">{facility.description}</p>
                <Link
                  href={`/fasilitas/${facility.slug}`}
                  className="mt-auto inline-flex items-center gap-1 text-green-700 text-xs font-semibold group-hover:gap-2 transition-all"
                >
                  Detail Fasilitas <ChevronRight size={13} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
